import React from 'react';
import styled, { css } from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { SVGIconStyled } from '@yme/atoms/svg-icon';
import { Link } from '@yme/components/Link';
import { colorBrandYamahaRed, colorCoreBackground1000, colorCoreBlack700, colorCoreBlack900Base, colorCoreGray100, colorCoreGray200, colorCoreGray500, } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
const megaMenuDesktopWidth = '1440px';
const menuDesktopWidth = '366px';
const menuWidth = '260px';
const subMenuWidth = '228px';
const unitSubMenuDesktopWidth = css `
  ${({ isExtraMenuShowed }) => `calc(${megaMenuDesktopWidth} - ${isExtraMenuShowed ? `${subMenuWidth} * 2` : subMenuWidth} - ${menuDesktopWidth})`};
`;
const unitSubMenuSmallDesktopWidth = css `
  ${({ isExtraMenuShowed }) => `calc(100vw - ${isExtraMenuShowed ? `${subMenuWidth} * 2` : subMenuWidth} - ${menuWidth})`};
`;
export const UnitWrapperStyled = styled.li ``;
export const SubMenuWrapperStyled = styled.div `
  position: absolute;
  top: 0;
  ${({ isRightToLeft }) => (isRightToLeft ? 'left' : 'right')}: 0;
  z-index: ${Z_INDEX.level2};
  display: flex;
  flex-direction: column;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s, visibility 0s 0.3s;
  height: 100%;
  border-left: 1px solid ${colorCoreGray500};
  border-right: 1px solid ${colorCoreGray500};
  cursor: default;

  &::before {
    content: '';
    position: absolute;
    display: block;
    width: 10px;
    height: 100%;
    top: 0;
    ${({ isRightToLeft }) => (isRightToLeft ? 'left' : 'right')}: 100%;
  }
`;
export const SubMenuStyled = styled.ul `
  width: ${({ isUnitSubmenu }) => (isUnitSubmenu ? unitSubMenuDesktopWidth : subMenuWidth)};
  flex-grow: 1;
  margin: 0;
  box-sizing: border-box;

  ${CustomScroll};

  max-height: 560px;
  padding: 0;
  border: none;
  border-bottom: 6px solid transparent;

  background-color: ${({ isUnitSubmenu }) => isUnitSubmenu ? colorCoreGray200 : colorCoreBackground1000};

  flex-direction: column;

  ${ADAPTIVE.maxWidth.desktop} {
    width: ${({ isUnitSubmenu }) => (isUnitSubmenu ? unitSubMenuSmallDesktopWidth : subMenuWidth)};
  }

  ${({ isUnitSubmenu }) => isUnitSubmenu &&
    css `
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      align-content: flex-start;
      flex-wrap: wrap;
      padding: 10px ${INDENT.xs} ${INDENT.xs};
      border-right: none;

      ${CustomScroll};

      border-left: 1px solid ${colorCoreGray500};
      max-height: calc(100vh - (80px + 40px));

      ${ADAPTIVE.maxWidth.desktop} {
        flex-direction: column;
        flex-wrap: nowrap;
      }
    `};

  li {
    text-decoration: none;
    list-style-type: none;
    display: flex;
    justify-content: space-between;
    padding: ${({ isRightToLeft }) => isRightToLeft
    ? `18px ${INDENT.xs} 18px ${INDENT.xxxxs}`
    : `18px ${INDENT.xxxxs} 18px ${INDENT.xs}`};

    cursor: pointer;

    span {
      ${getTextStyles('Ubuntu', 400, 14, 20)}
      display: inline-flex;
      align-items: center;
      text-transform: none;
    }

    &:hover {
      > span {
        a {
          font-weight: 400;
          color: ${colorCoreBlack700};
          text-decoration: underline;
        }
      }
      > span {
        font-weight: 700;

        svg {
          path {
            stroke: ${colorBrandYamahaRed};
          }
        }
      }

      ul > ${UnitWrapperStyled}:hover {
        color: ${colorCoreBlack900Base};
      }
    }
  }

  ${UnitWrapperStyled} {
    display: block;

    width: ${({ isExtraMenuShowed }) => isExtraMenuShowed ? `calc(100% / 3 - ${INDENT.xxxs})` : `calc(100% / 4 - ${INDENT.xxxs})`};
    margin: ${INDENT.xxxxs};
    padding: 0;

    ${ADAPTIVE.maxWidth.desktop} {
      width: 100%;
      margin: ${INDENT.xxxxs} 0;
    }
  }

  ${({ isRightToLeft }) => (isRightToLeft ? 'left: 0' : 'right: 0')};
`;
/* eslint-disable @typescript-eslint/no-unused-vars */
export const MenuLinkStyled = styled(({ isRightToLeft, ...props }) => React.createElement(Link, { ...props })) `
  position: relative;
  display: inline-block;

  ${({ isRightToLeft }) => (isRightToLeft ? 'padding-left: 22px' : 'padding-right: 22px')};

  ${SVGIconStyled} {
    position: absolute;
    bottom: 2px;
    display: inline;
    ${({ isRightToLeft }) => (isRightToLeft ? 'margin-right: 6px' : 'margin-left: 6px')};
  }
`;
export const TwoLevelMenuStyled = styled.div `
  position: relative;
  width: 366px;

  @media only screen and (max-height: 540px) {
    min-height: 290px;
  }

  background-color: ${colorCoreGray100};
  ${({ isRightToLeft }) => isRightToLeft
    ? `border-left: 1px solid ${colorCoreGray500}`
    : `border-right: 1px solid ${colorCoreGray500}`};

  ${ADAPTIVE.maxWidth.desktop} {
    width: 260px;
  }
`;
export const TwoLevelMenuWrapperStyled = styled.div `
  display: flex;
  position: relative;
  justify-content: space-between;
  height: 420px;
`;
export const TwoLevelMenuCardStyled = styled(FlexWrapper) `
  min-width: 50%;

  > div {
    width: 100%;
  }
`;
